module.exports = __webpack_public_path__ + "static/media/stop-18.8f67d5ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-18.svg
// module id = 1363
// module chunks = 0